import React from "react";
import { useSelector } from "react-redux";

function Frontend() {
  const es_en = useSelector((state) => state.translation);
  return (
    <div className="skills__content">
      <h3 className="skills__title">{es_en ? "Front-End" : "Front-End"}</h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <box-icon name="angular" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Angular</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="css3" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">CSS</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="html5" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Html5</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="palette" type="solid" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Material</h3>
            </div>
          </div>
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <box-icon name="react" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">React</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="redux" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Redux</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="test-tube" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Jest/Karma</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="figma" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Figma</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Frontend;
